<div class="wrapper">
  <div class="container" (click)="chooseType(0)">
    <img class="boxImage" src="../../../../../assets/svg/box.svg" />
    <div>{{ 'cubic_load' | translate }}</div>
  </div>

  <div class="container" (click)="chooseType(1)">
    <img class="barrelImage" src="../../../../../assets/svg/barrel.svg" />
    <div>{{ 'barrel' | translate }}</div>
  </div>

  <div class="container" (click)="chooseType(2)">
    <img class="pipeImage" src="../../../../../assets/svg/pipe.svg" />
    <div>{{ 'pipe' | translate }}</div>
  </div>
</div>
